<script setup>
</script>

<style>
</style>

<template>
	<div>
		Welcome to the blank
		<strong>{{ $route.meta.title }}</strong> page!
	</div>
</template>

